<template>
  <v-tooltip max-width="240" top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon color="grey " v-bind="attrs" v-on="on" :small="small" dark>
        mdi-information-outline
      </v-icon>
    </template>
    <span>{{ message }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'InformationTooltip',
  props: {
    message: String,
    small: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
}
</script>
